export default __webpack_public_path__ + "static/media/sticker-w.21b03b8e.png";